const state = {
    prepareList: [],
  }
  const mutations = {
    SET_PREPARELIST: (state, list) => {
      state.prepareList = list
    },
  }
  const actions = {
    set_prepareList({ commit }, list) {
      commit('SET_PREPARELIST', list)
    },
  }
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  }


// WEBPACK FOOTER //
// ./src/store/modules/lesson.js